TS.ns('WL');

WL.leasingOfferPartnersModel = new Class({
    Extends: WL.documentBase,

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        me.commandIsVisible = ko.computed(function () {
            return me.ReadOnly() !== true;
        });

        var partnerList = me.getDomainProperty('dgLeasingOfferXPartnerCollection_Property');
        if (partnerList) {
            partnerList.on('addNew', me.onPartnerAdded);
            partnerList.getFieldByName('gcPartner_Field').allowInput = false;
            partnerList.getFieldByName('gcPartner_Field').on('propertyChanged', me.onPartnerChanged, me);
            partnerList.getFieldByName('gcRole_Field').on('propertyChanged', me.onRoleChanged, me)
            partnerList.on('cellBeginEdit', me.onPartnerListBeginEdit);

            partnerList.getFieldByName('gcApplicationNumber_Field').renderer = "hyperlinkGrid";     

            TS.UI.Renderers.grid.smallWrap = {
                getCellClass: function (field, dataItem) {
                    return 'wrap-text';
                } 
            };

            TS.UI.Renderers.grid.hyperlinkGrid = {
                getCellClass: function (field, dataItem) {
                    return 'grid-hyperlink';
                }
            };

            partnerList.getCommand('Delete').InternalVisible = me.commandIsVisible;
            partnerList.getCommand('Add').InternalVisible = me.commandIsVisible;
        }

        var warrantyList = me.getDomainProperty('dgDocumentWarrantyCollection_Property');
        if (warrantyList) {
            warrantyList.getFieldByName('gcWarrantyItemName_Field').allowInput = false;
            warrantyList.getFieldByName('gcWarrantyItemName_Field').on('propertyChanged', me.onWarrantyChanged, me);
            var guarantorField = warrantyList.getFieldByName('gcGuarantor_Field');
            if (guarantorField) {
                guarantorField.on('propertyChanged', me.onGuarantorChanged, me);
            }
        }


    },

    onPartnerListBeginEdit: function (e) {
        var me = this,
            owner = me._Domain,
            partnerList = owner.getDomainProperty('dgLeasingOfferXPartnerCollection_Property');

        if (e.fieldName == 'LeasingApplicationNumber') {
            e.preventDefault();

            if (partnerList.SelectedItem().LeasingApplicationNumber() == null)
                return;
             
            owner.performServerCommand({
                cmd: 'OpenApplication',
                submitModel: true,
                extraData: { ApplicationNumber: partnerList.SelectedItem().LeasingApplicationNumber(), IsOpenedFromRelatedPartners: true },
                blockUI: false
            });
        }
        else if (owner.ReadOnly() === true) {
            e.preventDefault();
        }
    },

    onPartnerAdded: function (e) {
        var me = this,
            owner = me._getOwner();

        owner.performServerCommand({
            cmd: 'AddPartner',
            submitModel: true,
            blockUI: true
        })
    },

    onPartnerChanged: function (selectedRecord) {
        var me = this,
            partnerList = me.getDomainProperty('dgLeasingOfferXPartnerCollection_Property');

        if (selectedRecord.sender.SelectedItem()) {
            partnerList.SelectedItem().PartnerTypeId(selectedRecord.sender.SelectedItem().PartnerTypeId);
            partnerList.SelectedItem().PartnerTypeName(selectedRecord.sender.SelectedItem().PartnerTypeName);
            partnerList.SelectedItem().UniqueID(selectedRecord.sender.SelectedItem().UniqueID);
            partnerList.SelectedItem().GovFlag(selectedRecord.sender.SelectedItem().GovFlag);
        }
    },

    onRoleChanged: function (selectedRecord) {
        var me = this,
            partnerList = me.getDomainProperty('dgLeasingOfferXPartnerCollection_Property');

        if (selectedRecord.sender.SelectedItem()) {
            me.performServerCommand({
                cmd: 'SetBrowserFilter',
                submitModel: true,
                extraData: {
                    UID: partnerList.SelectedItem().UID
                },
                blockUI: true
            });
        }
    },


    onWarrantyChanged: function (selectedRecord) {
        var me = this,
            warrantyList = me.getDomainProperty('dgDocumentWarrantyCollection_Property');

        if (selectedRecord.sender.SelectedItem()) {
            warrantyList.SelectedItem().ItemCode(selectedRecord.sender.SelectedItem().ItemCode);
            warrantyList.SelectedItem().SiteId(me.Document.SiteId());
        }
    },

    onGuarantorChanged: function (selectedRecord) {
        var me = this,
            warrantyList = me.getDomainProperty('dgDocumentWarrantyCollection_Property');

        if (selectedRecord.sender.SelectedItem()) {
            warrantyList.SelectedItem().PartnerCode(selectedRecord.sender.SelectedItem().PartnerCode);
        }
    },

});

